





















































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import number from "../../a.framework/utils/number";

const activityManagementModule = namespace("activityManagement");

@Component({})
export default class ManagementDetail extends Vue {
  @activityManagementModule.State("activityDetail") activityDetail!: any;
  // @activityManagementModule.Getter("getterLaunchCouponList") list!: any;
  // @activityManagementModule.State("launchCouponPage") pages!: any;
  // @activityManagementModule.State("launchCouponListPageLoading")
  // launchCouponListPageLoading!: boolean;

  finished: boolean = false;
  loading: boolean = false;
  activityId: any = "";
  couponActivityId: string = "";
  couponActivityName: string = "";
  pages: any = {
    finished: false,
    loading: false,
    total: 0,
    pageNum: 1,
    pageSize: 10,
    couponAvailableList: []
  };
  activtyStatus: any = {
    "0": "待配置",
    "1": "未开始",
    "2": "暂停",
    "3": "已结束",
    "4": "待启动",
    "5": "已废弃",
    "6": "待审核"
  };

  // get loadingShow() {
  //   return this.loading;
  // }
  // set loadingShow(newVal) {
  //   this.loading = this.launchCouponListPageLoading;
  // }
  created() {
    this.activityId = this.$route.query.activityId;
    this.couponActivityId = this.$route.query.activityId + "";
    this.couponActivityName = this.$route.query.activityName + "";
  }
  mounted() {
    this.onInit();
  }

  onInit() {
    this.getActivityDetail();
    // this.getLaunchCouponList();
  }

  getActivityDetail() {
    this.$store.dispatch("activityManagement/getActivityDetail", {
      activityId: this.activityId
    });
    this.loading = false;
  }

  getLaunchCouponList() {
    let self = this;
    this.$store
      .dispatch("activityManagement/getLaunchCouponList", {
        couponActivityId: self.activityId,
        pageNum: self.pages.pageNum,
        pageSize: self.pages.pageSize
      })
      .then(({ success, error }) => {
        self.pages.loading = false;
        if (success) {
          self.pages.total = success.data.total;

          const _list = success.data.list.map((item: any) => {
            let _item = item;
            _item.couponGetStartTime = self.$format(
              _item.couponGetStartTime,
              "YYYY.MM.DD"
            );
            _item.couponGetEndTime = self.$format(
              _item.couponGetEndTime,
              "YYYY.MM.DD"
            );
            _item.activityStatus = self.activtyStatus[`${item.activityStatus}`];
            return _item;
          });
          if (
            self.pages.pageNum >= success.data.pages ||
            success.data.total == 0
          ) {
            self.pages.finished = true;
          }
          self.pages.pageNum = self.pages.pageNum + 1;
          self.pages.couponAvailableList = [
            ...self.pages.couponAvailableList,
            ..._list
          ];
        }
      });
  }
  addCoupon() {
    if (
      this.activityDetail.activityStatus == "已废弃" ||
      this.activityDetail.activityStatus == "已结束"
    ) {
      (this as any).$notify({
        title: "",
        message: `活动${this.activityDetail.activityStatus}`,
        duration: 1000
      });
      return;
    }
    this.$router.push({
      path: `/couponPutin`,
      query: {
        couponActivityId: this.couponActivityId,
        couponActivityName: this.couponActivityName
      }
    });
  }
  onLoadList() {
    this.getLaunchCouponList();
  }
}
